<template>
  <div class="main">
    <div class="try-container">
      <form class="form" @submit.prevent="submit">
        <div class="form-list">
          <div class="form-group" :class="{ 'form-group--error': $v.contact.$error }">
            <label class="form-label">
              联系人姓名
              <i>*</i>
            </label>
            <input class="form-input" placeholder="请输入身份证姓名" v-model.trim.lazy="$v.contact.$model" />
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.companyName.$error }">
            <label class="form-label">
              企业名称
              <i>*</i>
            </label>
            <input
              class="form-input"
              placeholder="请输入企业名称"
              v-model.trim.lazy="$v.companyName.$model"
            />
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.phoneNumber.$error }">
            <label class="form-label">
              手机号码
              <i>*</i>
            </label>
            <input
              class="form-input"
              placeholder="请输入手机号码"
              v-model.trim.lazy="$v.phoneNumber.$model"
              type="number"
              pattern="\d*"
            />
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.checkCode.$error }">
            <label class="form-label">
              短信验证码
              <i>*</i>
            </label>
            <input
              class="form-input code-input"
              placeholder="请输入验证码"
              v-model.trim.lazy="$v.checkCode.$model"
              type="number"
              pattern="\d*"
            />
            <!-- 这里的组件化是为了解决setInterval实现倒计时的情况下保证 input 正常输入-->
            <v-time
              :required="$v.phoneNumber.required"
              :rulePhone="$v.phoneNumber.rulePhone"
              :phoneNumber="phoneNumber"
            ></v-time>
          </div>

          <div class="form-group">
            <label class="form-label">
              总部地址
              <i>*</i>
            </label>
            <area-select type="text" v-model="selected" :data="pca"></area-select>
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.street.$error }">
            <label class="form-label">
              详细地址
              <i>*</i>
            </label>
            <input class="form-input" placeholder="请输入详细地址" v-model.trim.lazy="street" />
          </div>

          <div class="form-group">
            <label class="form-label">
              所属部门
              <i></i>
            </label>
            <input class="form-input" placeholder="请输入所属部门" v-model.trim.lazy="department" />
          </div>

          <div class="form-group">
            <label class="form-label">
              职位
              <i></i>
            </label>
            <input class="form-input" placeholder="请输入职位" v-model.trim.lazy="position" />
          </div>

          <div class="form-group" :class="{ 'form-group--error': $v.email.$error }">
            <label class="form-label">
              邮箱
              <i></i>
            </label>
            <input class="form-input" placeholder="请输入邮箱" v-model.trim.lazy="$v.email.$model" />
          </div>
          <div class="form-group" :class="{ 'form-group--error': $v.other.$error }">
            <label class="form-label">
              其他联系方式
              <i></i>
            </label>
            <input class="form-input" placeholder="请输入微信/QQ" v-model.trim.lazy="$v.other.$model" />
          </div>
        </div>
        <button class="form-button" type="submit" :disabled="submitStatus === 'PENDING'">申请使用</button>
      </form>
    </div>
  </div>
</template>
<script>
import { required, numeric } from "vuelidate/lib/validators";
import {
  ruleContacts,
  rulePhone,
  ruleEmail,
  ruleOther
} from "@/assets/js/rule-validators.js";

import "vue-area-linkage/dist/index.css";
import { pca, pcaa } from "area-data";

import HTTP from "@/api/index";
import vTime from "@/components/vtime/vtime";
export default {
  components: {
    vTime
  },
  data() {
    return {
      contact: "", //联系人姓名
      companyName: "", //企业名称
      phoneNumber: "", //手机号码
      checkCode: "", //验证码
      street: "", //详细地址
      department: "", //部门
      position: "", //职位
      email: "", //邮箱
      other: "", //其他联系方式
      selected: ["440000", "440300"],
      pca: pca,
      pcaa: pcaa,
      submitStatus: ""
    };
  },
  validations: {
    contact: {
      required,
      ruleContacts
    },
    companyName: {
      required
    },
    phoneNumber: {
      required,
      rulePhone
    },
    checkCode: {
      required,
      numeric
    },
    street: {
      required
    },
    email: {
      ruleEmail
    },
    other: {
      ruleOther
    }
  },
  props: ["status"],
  mounted() {
    this.$emit("update:status", false);
    document
      .querySelector("header")
      .setAttribute("style", "background: #213d81");
  },
  beforeDestroy() {
    this.$emit("update:status", true);
    document.querySelector("html").removeAttribute("style");
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        if (!this.$v.contact.required || !this.$v.contact.ruleContacts) {
          this.$layer.msg("请输入正确的联系人姓名");
          return;
        }
        if (!this.$v.companyName.required) {
          this.$layer.msg("请输入企业名称");
          return;
        }
        if (!this.$v.phoneNumber.required || !this.$v.phoneNumber.rulePhone) {
          this.$layer.msg("请输入正确的手机号码");
          return;
        }
        if (!this.$v.checkCode.required) {
          this.$layer.msg("请输入正确的验证码");
          return;
        }
        if (!this.$v.street.required) {
          this.$layer.msg("请输入详细地址");
          return;
        }
        if (!this.$v.email.ruleEmail) {
          this.$layer.msg("邮箱格式不正确");
          return;
        }
        if (!this.$v.other.ruleOther) {
          this.$layer.msg("其他联系方式格式不正确");
          return;
        }
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";
        // this.$layer.loading({ content: "请等待..." });
        console.log({
          name: this.contact,
          enterprise: this.companyName,
          mobilePhone: this.phoneNumber,
          mvCode: this.checkCode,
          address: this.selected[0] + this.selected[1] + this.street
        });
        HTTP.saveSubmit({
          name: this.contact,
          enterprise: this.companyName,
          mobilePhone: this.phoneNumber,
          mvCode: this.checkCode,
          address: this.selected[0] + this.selected[1] + this.street,
          dept: this.department,
          title: this.position,
          email: this.email,
          other: this.other,
          type: 2 //1厚科云 2厚科
        }).then(res => {
          console.log(res);
          this.submitStatus = "OK";
          this.$layer.msg(res.desc);
          if (res.success == "1") {
            // this.$router.push({ name: "Step", params: { name: this.contact } });
            this.$router.push({ path: "/step", query: { name: this.contact } });
          }
        });
      }
    }
  }
};
</script>
<style lang='scss' scoped>
.try-container {
  width: 100%;
  background: #fff;
  padding: 96px 32px;

  .form {
    .form-list {
      .form-group {
        width: 686px;
        margin-bottom: 48px;
        & /deep/ .area-select {
          margin-top: 16px;
          width: 324px;
          height: 80px;
          background: #eff0f4;
          border-radius: 40px;
          margin-left: 16px;
          border: none;
          .area-selected-trigger {
            padding: 20px 48px 20px 32px;
          }
          .area-select-icon {
            right: 20px;
          }
          .area-selectable-list-wrap {
            border: 1px solid #eff0f4;
          }
        }

        & /deep/ .area-select:first-child {
          margin-left: 0;
        }

        .form-label {
          display: block;
          height: 56px;
          line-height: 56px;
          font-size: 28px;
          font-weight: 400;
          color: #a8acb9;
          padding: 0 32px;
          i {
            color: #ea3047;
            margin-left: 6px;
            vertical-align: middle;
          }
        }

        .form-input {
          margin-top: 16px;
          width: 100%;
          height: 80px;
          border: 1px solid #eff0f4;
          background: #eff0f4;
          border-radius: 40px;
          border: none;
          outline: none;
          font-size: 28px;
          padding: 0 32px;
        }

        .code-input {
          width: 466px;
          vertical-align: bottom;
        }

        .form-code {
          margin-top: 8px;
          margin-left: 8px;
          border: 1px solid #eff0f4;
          background: #eff0f4;
          font-size: 28px;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.65);
          width: 204px;
          height: 80px;
          border-radius: 40px;
        }
      }

      .form-group--error {
        animation-name: shakeError;
        animation-fill-mode: forwards;
        animation-duration: 0.6s;
        animation-timing-function: ease-in-out;
        .form-input {
          border: 1px solid #f57f6c;
        }
      }

      @keyframes shakeError {
        0% {
          transform: translateX(0);
        }
        15% {
          transform: translateX(0.375rem);
        }
        30% {
          transform: translateX(-0.375rem);
        }
        45% {
          transform: translateX(0.375rem);
        }
        60% {
          transform: translateX(-0.375rem);
        }
        75% {
          transform: translateX(0.375rem);
        }
        90% {
          transform: translateX(-0.375rem);
        }
        100% {
          transform: translateX(0);
        }
      }
    }
    .form-button {
      display: block;
      margin: 96px auto 0;
      width: 352px;
      height: 80px;
      line-height: 80px;
      text-align: center;
      border-radius: 8px;
      background: #213d81;
      font-size: 32px;
      font-weight: 400;
      color: #fff;
    }
  }
}
</style>
